import { checkHasComplete } from '@/common/utils'

type FlowIds =
  | 'additionalDetails'
  | 'financial'
  | 'identity'
  | 'residential'
  | 'Landlord'
  | 'Employment'
  | 'Accountant'
  | 'guarantor'
  | 'company'

type FlowStageId =
  | 'proofOfIdentity'
  | 'tenantDetails'
  | 'selfie'
  | 'addressDetails'
  | 'forwardingAddress'
  | 'incomeDetails'
  | 'adverseCredit'
  | 'Tenant Information'
  | 'landlordDetails'
  | 'employerReference'
  | 'termsAndConditions'
  | 'accountantReference'
  | 'guarantorDetails'
  | 'companyDetails'

const displayNames: Record<FlowIds, string> = {
  additionalDetails: 'Additional Details',
  financial: 'Financial',
  identity: 'Identity',
  residential: 'Residential',
  Landlord: 'Landlord Reference',
  Accountant: 'Accountant Reference',
  Employment: 'Employer Reference',
  guarantor: 'Guarantor',
  company: 'Organisation',
}

const flowIcons: Record<FlowIds, string> = {
  additionalDetails: 'fa-info-circle',
  financial: 'fa-credit-card',
  identity: 'fa-address-card',
  residential: 'fa-building',
  Landlord: 'fa-address-card',
  Employment: 'fa-building',
  Accountant: 'fa-address-card',
  guarantor: 'fa-user-lock',
  company: 'fa-building',
}

const stageDisplayNames: Record<FlowStageId, string> = {
  proofOfIdentity: 'Proof of Identity',
  tenantDetails: 'Tenant Details',
  selfie: 'Selfie',
  addressDetails: 'Address Details',
  forwardingAddress: 'Forwarding Address',
  incomeDetails: 'Income Details',
  adverseCredit: 'Adverse Credit',
  'Tenant Information': 'Tenant Information',
  landlordDetails: 'Landlord Details',
  employerReference: 'Employer Details',
  termsAndConditions: 'Terms and Conditions',
  accountantReference: 'Accountant Details',
  guarantorDetails: 'Guarantor Details',
  companyDetails: 'Organisation Details',
}

const isFlowId = (flowId: string): flowId is FlowIds =>
  Object.prototype.hasOwnProperty.call(displayNames, flowId)

const isFlowStageId = (stageId: string): stageId is FlowStageId =>
  Object.prototype.hasOwnProperty.call(stageDisplayNames, stageId)

export const mapFlowIdToDisplayName = (flowId: string) =>
  isFlowId(flowId) ? displayNames[flowId] : flowId

export const mapFlowIdToIcon = (flowId: string) =>
  isFlowId(flowId) ? flowIcons[flowId] : ''

export const mapFlowStageToDisplayName = (stageId: string) =>
  isFlowStageId(stageId) ? stageDisplayNames[stageId] : stageId

export interface ActiveFlowProgress {
  flows: Record<string, { completed: boolean }>
  recommendations: Array<{ completed: boolean }>
}

export const getActiveFlow = <T extends { id: string | null; completed: boolean }>(
  data: T[],
  progress: ActiveFlowProgress,
): T | undefined => {
  const query = new URLSearchParams(window.location.search)
  const flowFromParam = query.get('flow') ?? undefined

  return !checkHasComplete(progress)
    ? data.find(flow => flow.id === flowFromParam || flow.completed === false)
    : data[data.length - 1]
}
